import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { PermitService } from 'app/services/permit.service';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'app/services/application.service';
import { environment } from 'environments/environment';
import { PopupService } from 'app/services/shared/popup.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-permit-certificate-return',
  templateUrl: './permit-certificate-return.component.html',
  styleUrls: ['./permit-certificate-return.component.css']
})
export class PermitCertificateReturnComponent implements OnInit {
  form: UntypedFormGroup;
  isLoading: boolean = false;
  message = 'Loading...'
  btnRadio:any;
  constructor(private formBuilder: UntypedFormBuilder,private permitSevc:PermitService,
    private toastr:ToastrService,public applicationService: ApplicationService,private popConfirm: PopupService,private confirmDialogService: ConfirmDialogService) { }

  ngOnInit() {
    this.initForm();
  }
  initForm() {
    this.form = this.formBuilder.group({
      permit_num: ['', [<any>Validators.required]],
      face_value: ['', [<any>Validators.required]],
      carrier_name: ['', [<any>Validators.required]],
      btnRadio: ['', [<any>Validators.required]],
    });
  }
  confirm(){
    if(!this.form.value.permit_num){
      return this.toastr.error('Please enter permit number','Permit Number')
    }
    if(!this.form.value.face_value){
      return this.toastr.error('Please enter face value number','Face Value Number')
    }
    this.isLoading = true;
    let permit_issue = 0;
    if (this.form.value.permit_num.includes('/')){
      permit_issue = this.form.value.permit_num.substring(this.form.value.permit_num.indexOf('/')+1).trim();
      if(!permit_issue){
        permit_issue = 0
      }
      this.form.value.permit_num = this.form.value.permit_num.substring(0, this.form.value.permit_num.indexOf('/'));
      //console.log(permit_issue)
      //console.log(this.form.value.permit_num)
    }
    //console.log(this.form.value.permit_num);
    this.permitSevc.getPermitReturn(this.form.value.permit_num).subscribe((data: any) =>{
      //console.log(data)
      if(data.face_value_num != this.form.value.face_value){
        this.isLoading = false;
        return this.toastr.error('Sorry permit and face value numbers do not match','Face Value Number')
      }
      
      if(data.permit_issue != permit_issue){
        this.isLoading = false;
        return this.toastr.error('Unable to locate the permit using permit number.','Permit Number')
      }
      //console.log(data);
      this.applicationService.getById(data.application_id).subscribe((data:any) =>{
        //console.log(data)
        this.loadData(data)
        let status_id = +environment.authWebApi.systemData.Configurations.find(config => config.Code == "PermitStatus5").Value;

        //check status

        if(data.status_id === status_id){
          this.isLoading = false;
          return this.toastr.info('Permit already returned','Permit');
        }

        //get permit type date
        let createdDate = new Date(data.permit.date_valid_to);
        // if(data.permit_type.permit_months > 0){
        //   createdDate.setMonth(createdDate.getMonth() + data.permit_type.permit_months)
        //   }
          
        //   if(data.permit_type.permit_days > 0){
        //   createdDate.setDate(createdDate.getDate() + data.permit_type.permit_days)
          
        //   }
        //   if(data.permit_type.permit_years > 0){
        //   createdDate.setFullYear(createdDate.getFullYear() + data.permit_type.permit_years)
          
        //   }
          
          let checkNowDate = new Date();
          //check expiry date
          //console.log('current date'+createdDate)
          //console.log('now date'+checkNowDate)

          if (createdDate.getTime() > checkNowDate.getTime()){
            this.isLoading = false;
               return this.onConfirm(data);
          }


        data.permit.date_12 = new Date();
        data.permit.status_id = status_id;
        data.status_id = status_id;
        this.applicationService.update(data).subscribe(x =>{
          //console.log(x)
          this.permitSevc.upadatePermit(data.permit).subscribe(result => {
            this.isLoading = false;
            return this.toastr.success('Permit returned successfully','Permit');
          })
        })
        

        //console.log(status_id);
        
      });
     
    },err =>{
      this.isLoading = false;
      return this.toastr.error('Unable to locate the permit using permit number.','Permit Number')
    })
  }
  loadData(data: any) {
    this.form.patchValue({
      carrier_name:data.carrier.name
                                    
    });
  }
  onConfirm(data) {    
    let status_id = +environment.authWebApi.systemData.Configurations.find(config => config.Code == "PermitStatus5").Value;

    this.popConfirm.showYesNo('Permit Not Expired', `The permit for carrier ${data.carrier.name}  is not expired! Do you want to return it anyway?`, null,'Yes', 'No')
                .subscribe((isConfirmed) => {
                  if (isConfirmed) {
                    this.isLoading = true;
                    data.permit.status_id = status_id;
                      data.status_id = status_id;
                      this.applicationService.update(data).subscribe(x =>{
                        //console.log(x)
                        this.permitSevc.upadatePermit(data.permit).subscribe(result => {
                          this.isLoading = false;
                          return this.toastr.success('Permit returned successfully','Permit');
                        })
                      })
                  } else {         
                    return;
                  }
                });
                this.confirmDialogService.confirmThis(`The permit for carrier ${data.carrier.name}  is not expired! Do you want to return it anyway?`, () => {  
          
                    this.isLoading = true;
                    data.permit.status_id = status_id;
                      data.status_id = status_id;
                      this.applicationService.update(data).subscribe(x =>{
                        //console.log(x)
                        this.permitSevc.upadatePermit(data.permit).subscribe(result => {
                          this.isLoading = false;
                          return this.toastr.success('Permit returned successfully','Permit');
                        })
                      })
                 
      
                }, () =>  {  
                  return;
                }) 
  }
}
